import rolesConfig from './roles.json';

const { ROLES, PRIORITY } = rolesConfig;

export { ROLES, PRIORITY };

export function allRolesName() {
  return Object.keys(ROLES).reduce((all, role) => [...all, ROLES[role].name], []);
}

export function prioritizeRoles(roles) {
  return PRIORITY.filter(role => roles.indexOf(role) !== -1);
}

export function getPrioritizedUserRole(roles, priorities = prioritizeRoles(roles)) {
  return priorities.find(role => roles.indexOf(role) !== -1) || '';
}

export function rolesWithTags() {
  return Object.keys(ROLES).reduce(
    (all, role) => ({ ...all, [ROLES[role].name]: ROLES[role].tag }),
    {},
  );
}

export function abbreviatedRoles(roles) {
  const tags = rolesWithTags();

  return prioritizeRoles(roles)
    .filter(role => tags[role])
    .map(role => tags[role])
    .join(', ');
}
